import Box from '@mui/material/Box';

import type { FunctionComponent } from 'react';

type TalentDirectoryBarChartProps = {
    readonly employees?: number;
    readonly jobs?: number;
    readonly learningOpportunities?: number;
    readonly withLearningOpportunities: boolean;
};

export const TalentDirectoryBarChart: FunctionComponent<TalentDirectoryBarChartProps> = ({
    employees = 0,
    jobs = 0,
    learningOpportunities = 0,
    withLearningOpportunities,
    // eslint-disable-next-line complexity
}) => (
    <Box
        sx={{
            alignItems: 'center',
            backgroundColor: (theme) =>
                employees + jobs + learningOpportunities === 0 ? theme.palette.cardborder.main : 'background.default',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            gap: '1px',
            height: '4px',
            width: '100%',
        }}
    >
        {employees > 0 && (
            <Box
                aria-label="Talent Directory Bar Chart Employees"
                sx={{
                    backgroundColor: (theme) => theme.palette.user.main,
                    flex: employees,
                    height: '100%',
                }}
            />
        )}
        {jobs > 0 && (
            <Box
                aria-label="Talent Directory Bar Chart Jobs"
                sx={{
                    backgroundColor: (theme) => theme.palette.jobposting.main,
                    flex: jobs,
                    height: '100%',
                }}
            />
        )}
        {withLearningOpportunities && learningOpportunities > 0 && (
            <Box
                aria-label="Talent Directory Bar Chart Learning Opportunities"
                sx={{
                    backgroundColor: (theme) => theme.palette.learningOpportunity.main,
                    flex: learningOpportunities,
                    height: '100%',
                }}
            />
        )}
    </Box>
);
